import axios from "axios";
import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectOrder(data) {
  return request({
    url: `/admin/mall/order/selectOrder`,
    method: "POST",
    data,
  });
}

/**
 * 查询子单列表
 * @param {*} data
 * @returns
 */
export function selectSubOrder(data) {
  return request({
    url: `/admin/mall/order/selectSubOrder`,
    method: "POST",
    data,
  });
}


/**
 * 新增
 * @param {*} data
 * @returns
 */
export function addOrder(data) {
  return request({
    url: `/admin/mall/order/addOrder`,
    method: "POST",
    data,
  });
}

/**
 * 更改主订单
 * @param {*} data
 * @returns
 */
export function updateOrder(data) {
  return request({
    url: `/admin/mall/order/update`,
    method: "POST",
    data,
  });
}

/**
 * 更改子订单
 * @param {*} data
 * @returns
 */
export function updateSubOrder(data) {
  return request({
    url: `/admin/mall/order/updateSub`,
    method: "POST",
    data,
  });
}

/**
 * 删除子订单
 * @param {*} data
 * @returns
 */
export function deleteOrder(data) {
  return request({
    url: `/admin/mall/order/deleteSub`,
    method: "POST",
    data,
  });
}



/**
 * 供应商查询订单
 * @param {*} data
 * @returns
 */
export function selectOrderByBusiness(data) {
  return request({
    url: `/admin/mall/order/selectOrderByBusiness`,
    method: "POST",
    data,
  });
}

/**
 *退款
 * @param {*} data
 * @returns
 */
export function rejectApi(data) {
  return request({
    url: `/admin/mall/order/reject`,
    method: "POST",
    data,
  });
}

/**
 * 获取商品折扣价格
 * @param {*} data
 * @returns
 */
export function getGoodsDiscount(data) {
  return request({
    url: `/admin/mall/order/getGoodsDiscount`,
    method: "POST",
    data,
  });
}


/**
 * 物流查询
 */
export function selectlogisticsByNumber(data) {
    return request({
    url: `/admin/mall/order/selectlogisticsByNumber`,
    method: "POST",
    data,
  });
}